import React from "react";
import "./app.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

export let gameStartSound = new Audio("../sound/gamestart.mp3");

function Start() {
  //let ambianceSound = new Audio("../sound/ambiance.mp3");
  //ambianceSound.loop = true;
  let infoSound = new Audio("../sound/info.mp3");

  return (
    <div className="main">
      <div className="cover">
        <div className="back"></div>
        <div className="front">
          <img src="../img/title.png" alt="cards"></img>
        </div>
      </div>
      <div className="buttonBar">
        <Button
          size="large"
          variant="outlined"
          color="error"
          component={Link}
          to="/info"
          onClick={() => {
            //infoSound.play();
          }}
        >
          HOW TO PLAY
        </Button>
        <Button
          size="large"
          variant="outlined"
          color="error"
          component={Link}
          to="/play"
          onClick={() => {
            //gameStartSound.play();
            //ambianceSound.play();
          }}
        >
          START GAME
        </Button>
      </div>
    </div>
  );
}

export default Start;
